import { ApiPropertyOptional } from '@nestjs/swagger';
import { Expose, Type } from 'class-transformer';
import {
  ArrayMaxSize,
  ArrayMinSize,
  IsArray,
  IsOptional,
  IsUUID,
  ValidateIf,
  ValidateNested,
} from 'class-validator';
import { UserUpdateDto } from './user-update.dto';
import { USER_RELATION_MAX_ITEMS } from './user-provision.dto';

/**
 * Body of PATCH /user/:id/full. Every key is optional and an omitted key is
 * left untouched; `roleIds` and `regionIds` are desired sets (the server
 * diffs them against the current rows).
 */
export class UserFullUpdateDto {
  @ApiPropertyOptional({ type: () => UserUpdateDto })
  @Expose()
  @IsOptional()
  @ValidateNested()
  @Type(() => UserUpdateDto)
  user?: UserUpdateDto;

  @ApiPropertyOptional({
    type: [String],
    format: 'uuid',
    description:
      'Desired set of role ids. A user always keeps at least one role.',
  })
  @Expose()
  @IsOptional()
  @IsArray()
  @ArrayMinSize(1)
  @ArrayMaxSize(USER_RELATION_MAX_ITEMS)
  @IsUUID('4', { each: true })
  roleIds?: string[];

  @ApiPropertyOptional({
    type: [String],
    format: 'uuid',
    description: 'Desired set of region ids.',
  })
  @Expose()
  @IsOptional()
  @IsArray()
  @ArrayMaxSize(USER_RELATION_MAX_ITEMS)
  @IsUUID('4', { each: true })
  regionIds?: string[];

  @ApiPropertyOptional({
    type: String,
    format: 'uuid',
    nullable: true,
    description:
      'Regional manager written to every user-region row of this user; null clears it.',
  })
  @Expose()
  @IsOptional()
  @ValidateIf((_object, value) => value !== null)
  @IsUUID('4')
  regionalManagerUserId?: string | null;
}
